import SongCredits from "@components/SongCredits";

export default SongCredits;
